import { get } from 'lodash';

export function getErrorMessage(error: Record<string, any>) {
  const errorBody = get(error, 'error.body')
    ? get(error, 'error.body')
    : get(error, 'body');
  const errorMessage =
    get(errorBody, 'error') === 'RuntimeError'
      ? get(errorBody, 'message')
      : get(errorBody, 'error');

  return errorMessage;
}

export function handleError(
  error: Record<string, any>,
  notify: any,
  fallbackKey = 'notify.error.update',
  translate?: (key: string) => string
) {
  const errorMessage = getErrorMessage(error);
  if (errorMessage === 'ActiveRecord::RecordInvalid') {
    notify(error.message, 'error');

    return;
  }

  if (typeof errorMessage !== 'undefined') {
    const key = `notify.error.${errorMessage}`;
    // Without a translate function, or if no key is provided, we can't tell
    // whether `key` has a real translation, so it is used as-is (existing
    // behaviour). When `translate` is given, an untranslated key (Polyglot
    // returns the key itself) falls back to `fallbackKey` instead of
    // surfacing the raw technical key (e.g. "notify.error.NameError").
    if (!translate || translate(key) !== key) {
      notify(key, 'error', { id: error.id });

      return;
    }
  }

  notify(fallbackKey, 'error');
}
